module.exports = "mutation ($reference: ID!, $data: ContractCreate!) {\n  ContractCreate(reference: $reference, data: $data) {\n    id\n  }\n}\n"